import { Storefront } from "@/icons";

import { FeedbackIcon } from "@/components/feedback";
import { EmptyState, Surface } from "@/components/ui";

/**
 * Thrown by the company bootstrap when /by-subdomain returns 404, so App can
 * tell "store doesn't exist" apart from real failures (which keep ErrorPage).
 */
export class StoreNotFoundError extends Error {
  constructor(subdomain: string) {
    super(`store not found for subdomain "${subdomain}"`);
    this.name = "StoreNotFoundError";
  }
}

export function StoreNotFoundPage() {
  return (
    <Surface surface="page" className="flex min-h-screen flex-col items-center justify-center px-6">
      <EmptyState
        size="section"
        headingLevel={1}
        illustration={<FeedbackIcon variant="warning" icon={Storefront} />}
        title="Hmm, não achamos essa loja"
        description="A gente procurou por todo lado, mas não tem nenhuma loja nesse endereço. Dá uma conferida no link, vai que foi só um errinho de digitação."
      />
    </Surface>
  );
}
